import request from 'services/axios';

export const deleteMyAd = async ({
  guid,
  type,
  delete_reason,
}: deleteMyAdProps) => {
  const response = await request.delete(`/api/v2/market/${type}`, {
    guid,
    delete_reason,
  });
  return response;
};
